// src/components/ThemeProvider.tsx
import React from "react";
import { ThemeProvider as NextThemeProvider } from "next-themes";
export { useTheme } from "next-themes";

// next-themes expects `attribute` to be either 'class' or a data-* attribute,
// or an array of those. Narrow our prop type accordingly.
type Attribute = 'class' | `data-${string}`;
type Props = {
  children: React.ReactNode;
  attribute?: Attribute | Attribute[];
  defaultTheme?: 'system' | string;
  enableSystem?: boolean;
};

export function ThemeProvider({
  children,
  attribute = "class",
  defaultTheme = "light",
  enableSystem = false,
}: Props) {
  return (
    <NextThemeProvider attribute={attribute} defaultTheme={defaultTheme} enableSystem={enableSystem}>
      {children}
    </NextThemeProvider>
  );
}